import { useCurrentProject } from "@radarly/core/project/use-cases";

export function useGroups() {
  return useCurrentProject()?.tags?.user;
}
